<template>
 <div class="main">
   <!--<section class="page page-subpage">-->

     <!--<vue-simplebar class="page page-subpage">-->
       <transition appear name="turnIn">
       <simplebar class="page page-subpage" data-simplebar-auto-hide="true" v-bind:class="{ 'linkIsClicked' : linkClicked }">

    <!-- <nav class="navigation">
      <ul class="menu menu-rsvp">
        <li><router-link to="/rsvp">RSVP</router-link></li>
      </ul>

      <ul class="menu menu-left">
        <li><router-link to="/schema">Schema</router-link></li>
        <li><router-link to="/florens">Florens</router-link></li>
      </ul>

      <ul class="menu menu-center">
        <li><router-link to="/rsvp">RSVP</router-link></li>
      </ul>

      <ul class=" menu menu-right">
        <li><router-link to="/ceremoni">Ceremoni</router-link></li>
        <li class="current"><router-link to="/middag">Middag</router-link></li>
      </ul>
    </nav> -->

    <navigation @link-clicked="linkClickedFunc" v-bind:linkClickedC="linkClicked"></navigation>

    <hr class="page-hr">

    <h1>Middag</h1>

    <div class="page-middag-mapwrap">
      <figure>
        <img src="../assets/pensavo.jpg" width="100%" height="auto" alt="Pensavo Peggio Restaurant"/>
      </figure>

    <!--style="width: 100%; height: 200px"-->
      <!-- <GmapMap
        :center="{lat:43.772911, lng:11.249519}"
        :zoom="17"
        map-type-id="terrain"
        :options="{styles: styles}"

      >
        <GmapMarker
          :position="{lat:43.7724, lng:11.24957}"
          :clickable="true"
         >
        </GmapMarker>
      </GmapMap> -->

      <!--komponent-->
      <my-google-map />
    </div><!--page-middag-mapwrap-->

    <p class="page-ingress">I middagen ingår förrätt, huvudrätt och efterrätt. Till huvudrätt kan man välja mellan kött (Florentisk T-benstek) eller vegetariskt alternativ. Meddela gärna vilken av rätterna ni vill äta när ni svarar på <router-link to="/rsvp">inbjudan</router-link>.</p>

    <hr class="hr-icons"/>

    <article class="page-middag-menu">
      <!--<hr class="page-hr"/>-->
      <!--<p>&#9753; &#10087;  🙛 🙙</p>-->
      <!--https://en.wikipedia.org/wiki/Fleuron_(typography) -->
      <h3>Förrätt</h3>
      <p>Bruschetta</p>
      <hr class="hr-ornament"/>
      <h3>Huvudrätt</h3>
      <p>Bistecca (Florentinsk T-bone steak), serveras med potatis, sallad och sås</p>
      <p class="page-middag-menu-alt">alternativt</p>
      <p>Vegetarisk huvudrätt</p>

      <hr class="hr-ornament"/>
      <h3>Efterrätt</h3>
      <p>Crème Brûlée <br/>Bröllopstårta</p>
    </article><!--page-middag-menu-->

    <h2>När &amp; var</h2>
    <p>Middagen börjar på kvällen <strong>kl. 20.00 den 24 juni 2022</strong>. Middagen hålls på restaurangen <a href="https://www.google.se/maps/dir/Hotel+Santa+Maria+Novella,+Piazza+di+Santa+Maria+Novella,+Florens,+Italien/Ristorante+Pensavo+Peggio,+Via+del+Moro,+51,+50123+Firenze+FI,+Italien/@43.7729246,11.2492417,19z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x132a51530b0b49f7:0x573ec4bdc857a34e!2m2!1d11.2501169!2d43.7733923!1m5!1m1!1s0x132a56abc9588dbb:0xa1498379d4ba360a!2m2!1d11.2495753!2d43.7723891!3e2" title="Se vägbeskrivning" target="_blank">Pensavo Peggio</a>, ca. 140 meter från <a href="https://www.hotelsantamarianovella.it/" title="Läs mer på hotellets hemsida" target="_blank">Santa Maria Novella Hotel</a>.</p>

    <p><strong>Restaurangen är även öppen för allmänheten under kvällen.</strong> Ange att ni tillhör bröllopssällskapet vid ankomst.</p>

    <hr class="hr-icons"/>

    <h2>Klädsel</h2>
    <p>Riktlinje för klädsel är samma som för ceremonin: mellan kavaj och smoking.</p>
    <p>&nbsp;</p>

    <!--<figure class="page-ceremoni-img">
      <img src="../assets/terrassen-opt.jpg" width="100%" height="auto" alt="Terrassen"/>
    </figure>-->

    <!-- <div class="google-map" ref="googleMap" id="map"></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
      />
    </template> -->

    <!--<div id="map"></div>-->
      <!-- <TravelMap class="travel-map"/> -->



     <!-- </vue-simplebar> -->
    </simplebar>
    </transition>
   <!--</section>page-->
  </div><!--main-->
</template>

<script>

import simplebar from 'simplebar-vue';
// import 'simplebar/dist/simplebar.min.css'; //importerar denna som vanlig scss istället med copy paste för att få den inbakad i vanliga css filen

import MyGoogleMap from '../components/MyGoogleMap';

import Navigation from '../components/Nav.vue';
import { setTimeout } from 'timers';

export default {
  name: 'middag',
  data () {
    return {
      styles: [
        {
          'featureType': 'administrative',
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'color': '#444444'
            }
          ]
        },
        {
          'featureType': 'landscape',
          'elementType': 'all',
          'stylers': [
            {
              'color': '#f2f2f2'
            }
          ]
        },
        {
          'featureType': 'landscape',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#f0e3ce'
            },
            {
              'lightness': '39'
            },
            {
              'gamma': '1.01'
            }
          ]
        },
        {
          'featureType': 'poi',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'road',
          'elementType': 'all',
          'stylers': [
            {
              'saturation': -100
            },
            {
              'lightness': 45
            }
          ]
        },
        {
          'featureType': 'road',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#ffffff'
            }
          ]
        },
        {
          'featureType': 'road.highway',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'simplified'
            }
          ]
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'labels.icon',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'transit',
          'elementType': 'all',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'water',
          'elementType': 'all',
          'stylers': [
            {
              'color': '#e7e1d6'
            },
            {
              'visibility': 'on'
            }
          ]
        },
        {
          'featureType': 'water',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#d9d9d9'
            }
          ]
        }
      ],
      linkClicked: false
    };
  },

  components: {
    simplebar,
    MyGoogleMap,
    Navigation
  },

  methods: {
    linkClickedFunc (emittedvalue) {
      this.linkClicked = emittedvalue;
      return this.linkClicked;
    },

    gmapShowSecondTime () {
      const vueMapContainer = document.getElementsByClassName('vue-map-container');
      // const bredd = vueMapContainer[0].offsetWidth;
      // vueMapContainer[0].style.width = bredd + 'px';
      vueMapContainer[0].style.padding = '25% 0'; // funkade bättre med att ändra paddingen för att sätta width än att sätta width för att tvinga fram kartan. Kartan visade sig annars inte när man gick in på sidan Middag en andra ggr.
      // console.log('calcwidth har kört');
    }
  },

  mounted: function () {
    // justering av höjden för scrollbar plugin
    const pageSubpage = document.getElementsByClassName('page-subpage')[0];
    const pageSubpageHeight = document.getElementsByClassName('page-subpage')[0].offsetHeight + 15;
    // console.log(pageSubpageHeight);
    pageSubpage.style.height = pageSubpageHeight + 'px';

    // lägg till bredden på .vue-map-container
    // const vueMapContainer = document.getElementsByClassName('vue-map-container');
    // const bredd = vueMapContainer[0].offsetWidth;
    // vueMapContainer[0].style.width = bredd + 'px';

    setTimeout(this.gmapShowSecondTime, 500);
  }

};

</script>